import { Title } from '@/components'
import React from 'react'
import whychooseusimage from "../../../assets/Image/home-img/why-us/WhyChooseUs.png"
import vector from "../../../assets/Image/home-img/why-us/vector.svg"
import vector2 from "../../../assets/Image/home-img/why-us/vector2.svg"
import vector3 from "../../../assets/Image/home-img/why-us/vector3.svg"
import vector4 from "../../../assets/Image/home-img/why-us/vector4.svg"
import Image from 'next/image'

export const WhyChooseUs = () => {
  const travelFeaturesPart1 = [
    {
      title: "First-Class Travel Experiences",
      description: "Experience 5-star hotels, VIP services, and premium destinations for the ultimate getaway",
      icon: vector,
    },
    {
      title: "Budget-Friendly Adventures",
      description: "Dream trips at unbeatable prices because travel should be for everyone!",
      icon: vector2,

    }
  ];

  const travelFeaturesPart2 = [
    {
      title: "Custom Travel Plans Just for You",
      description: "Tell us your travel style, and we’ll craft the perfect itinerary just for you!",
      icon: vector3,
    },
    {
      title: "Guided by the Best, Anywhere",
      description: "Expert guides bring destinations to life with local insights and personalized experiences",
      icon: vector4,
    }
  ];

  return (
    <div className='container'>
      <Title header='Why Travel with MS Tourism?' subtitle="Travel the World Without Breaking the Bank" />
      <div className='flex justify-between items-center gap-2 lg:flex-row flex-col'>
        <div className='flex gap-10 lg:gap-20 flex-col' >
          {travelFeaturesPart1.map((feature, index) => (
            <div key={index} className='flex flex-col items-center'>
              <Image src={feature.icon} alt='vector' />
              <h3 className='text-center font-semibold text-lg mt-4'>{feature.title}</h3>
              <p className='text-base text-center max-w-[30rem] mt-2'>
                {"&quot;" + feature.description + "&quot;"}
              </p>
            </div>
          ))}
        </div>


        <div data-aos="zoom-in">
          <Image src={whychooseusimage} alt='why Choose Us' />

        </div>

        <div className='flex gap-10 lg:gap-20 flex-col' >
          {travelFeaturesPart2.map((feature, index) => (
            <div key={index} className='flex flex-col items-center' >
              <Image src={feature.icon} alt='vector' />
              <h3 className='text-center font-semibold text-lg mt-4'>{feature.title}</h3>
              <p className='text-base text-center max-w-[30rem] mt-2'>
                {"&quot;" + feature.description + "&quot;"}
              </p>
            </div>
          ))}
        </div>

      </div>
    </div>
  )
}
